export default __webpack_public_path__ + "static/media/cx_cover_tln2sc.696655e9.jpg";